import { Currency, LenderName, MoneyDto, PaymentMethodRequest, PaymentMethodType } from '@nemuru-eng/js-api-client';

import { LoanConditionsGroup } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/ConditionsGroup/LoanConditionsGroup';
import { AbstractLoanPaymentMethod } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractLoanPaymentMethod';
import { SetupOptions } from '@/components/modules/Application/components/PaymentMethod/_shared/entities/PaymentMethod/AbstractPaymentMethod';
import { LoanConditions } from '@/components/modules/Application/components/PaymentMethod/_shared/types/LoanConditions';

// Extends AbstractLoanPaymentMethod because Card Onboarding is still a loan-shaped payment
// method (setup, setConditionFromLoanConditions, lender seeding) but conditional-less — no
// APR/term pricing like consumer loan. This is the Application calculator entity, not the
// checkout detail entity; it does not need Loan's docs/KYC/next-actions surface.
export class CardOnboardingPaymentMethod extends AbstractLoanPaymentMethod {
  protected ALLOWED_PAYMENT_METHOD_TYPES = [PaymentMethodType.CARD_ONBOARDING];

  public areOptionsConfigurable(): boolean {
    return false;
  }

  public setup(amount: number, currency: Currency, options?: SetupOptions): void {
    this.amount = amount;
    this.currency = currency;
    this._options = options ?? null;
    this.isSetup = true;
  }

  public seedProviderNames(lenderNames: LenderName[]): void {
    this.paymentMethodConditions = lenderNames.map((lenderName) => ({
      type: this.paymentMethodType,
      amount: new MoneyDto({ value: this.amount ?? 0, currency: this.currency }),
      currency: this.currency,
      conditions: {
        lenderName,
      },
    })) as NonNullable<typeof this.paymentMethodConditions>;
  }

  protected setAvailableFilters(): void {
    return;
  }

  protected getAvailableConditions(allConditions: LoanConditions[]): LoanConditions[] {
    return allConditions;
  }

  protected getSelectedTermCandidate(availableTerms: number[]): number {
    return availableTerms[availableTerms.length - 1];
  }

  protected getConditionsGroups(availableConditions: LoanConditions[], term: number): LoanConditionsGroup[] {
    const filteredConditions = availableConditions.filter((condition) => condition.term === term);
    return [new LoanConditionsGroup(filteredConditions)];
  }

  protected getSelectedConditionsGroupCandidate(conditionsGroups: LoanConditionsGroup[]): LoanConditionsGroup {
    return conditionsGroups[0];
  }

  public get proposedTerms(): number[] {
    return this.availableTerms;
  }

  public toDto(): PaymentMethodRequest {
    throw new Error('Card onboarding payment method cannot be converted to DTO');
  }
}
